<app-action-icon #iconCmp
                 [value]="isHome"
                 [state]="state"
                 (toggle)="toggleHome($event)"
                 class="airport-home-icon__container"
                 [class.airport-home-icon__container--active]="isHome"
                 [class.airport-home-icon__container--hover]="iconCmp.hover">
  <mat-icon
    [matTooltip]="tooltip"
    class="airport-home-icon__icon"
    [class.airport-home-icon__icon--active]="isHome"
    [class.airport-home-icon__icon--hover]="iconCmp.hover">
    {{icon}}
  </mat-icon>
</app-action-icon>
